export function isPaymasteredOp(args) {
    if (args.entryPointVersion === '0.6') {
        return args.paymasterAndData !== undefined && args.paymasterAndData !== '0x';
    }
    else if (args.entryPointVersion === '0.7') {
        return args.paymasterData !== undefined && args.paymasterData !== '0x';
    }
    else {
        // Version 0.8 is not supported yet
        throw new Error(`EntryPoint version ${args.entryPointVersion} is not supported`);
    }
}
